import FadeInUpOnScroll from "components/AnimationFadeup/FadeInUpOnScroll";
// import DiscoverMoreSlider from "components/DiscoverMoreSlider";
import SectionHero2 from "components/SectionHero/SectionHero2";
import SectionOurExperience from "components/SectionOurExperience";
import SectionOurIntroduction from "components/SectionOurIntroduction";
import SectionSliderProductCard from "components/SectionSliderProductCard";
import SectionSeo from "components/SectionSeo/SectionSeo";
import ProductImg1 from "images/Devi-Plastic/3-Heavy-Sink-Coupling.webp";
import ProductImg2 from "images/Devi-Plastic/3-LITE-MS-SS-SKREW.webp";
import ProductImg3 from "images/Devi-Plastic/4 -Heavy-with-Reducer.webp";
import ProductImg4 from "images/Devi-Plastic/4 -JUMBO.webp";
import ProductImg5 from "images/Devi-Plastic/4-HEAVY-ROYAL.webp";
import ProductImg6 from "images/Devi-Plastic/4-LITE-COUPLING.webp";
import { Helmet } from "react-helmet-async";
// import "lenis/dist/lenis.css";

function PageHome() {
  const dataofProducts: any = [
    {
      id: 1,
      name: "3 inch Heavy Sink Coupling",
      description:
        "Extra heavy sink coupling designed for strong grip and long-lasting drainage performance.",
      price: 99,
      image: ProductImg1,
      category: "Sink Coupling",
      tags: ["heavy", "sink", "durable"],
      link: "3-inch-heavy-sink-coupling",
      sizes: ["3 inch"],
      allOfSizes: ["3 inch"],
      status: "Best Seller",
    },
    {
      id: 2,
      name: "3 inch Lite MS & SS Screw Coupling",
      description:
        "Lightweight sink coupling with MS & SS screws for easy installation and secure fitting.",
      price: 79,
      image: ProductImg2,
      category: "Sink Coupling",
      tags: ["lite", "ms-screw", "ss-screw"],
      link: "3-inch-lite-ms-ss-screw",
      sizes: ["3 inch"],
      allOfSizes: ["3 inch"],
      status: "New in",
    },
    {
      id: 3,
      name: "4 inch Heavy Coupling with Reducer",
      description:
        "Heavy quality sink coupling with reducer, ideal for flexible pipe connections.",
      price: 119,
      image: ProductImg3,
      category: "Sink Coupling",
      tags: ["heavy", "reducer", "bathroom"],
      link: "4-inch-heavy-coupling-with-reducer",
      sizes: ["4 inch"],
      allOfSizes: ["4 inch"],
      status: "New in",
    },
    {
      id: 4,
      name: "4 inch Jumbo Sink Coupling",
      description:
        "Jumbo size sink coupling suitable for high water flow and commercial usage.",
      price: 139,
      image: ProductImg4,
      category: "Sink Coupling",
      tags: ["jumbo", "high-flow", "commercial"],
      link: "4-inch-jumbo-sink-coupling",
      sizes: ["4 inch"],
      allOfSizes: ["4 inch"],
      status: "Trending",
    },
    {
      id: 5,
      name: "4 inch Heavy Royal Sink Coupling",
      description:
        "Premium royal finish heavy sink coupling with superior strength and elegant design.",
      price: 149,
      image: ProductImg5,
      category: "Sink Coupling",
      tags: ["royal", "premium", "heavy"],
      link: "4-inch-heavy-royal-sink-coupling",
      sizes: ["4 inch"],
      allOfSizes: ["4 inch"],
      status: "Best Seller",
    },
    {
      id: 6,
      name: "4 inch Lite Sink Coupling",
      description:
        "Lightweight 4-inch sink coupling for regular household drainage needs.",
      price: 89,
      image: ProductImg6,
      category: "Sink Coupling",
      tags: ["lite", "household", "sink"],
      link: "4-inch-lite-sink-coupling",
      sizes: ["4 inch"],
      allOfSizes: ["4 inch"],
      status: "New in",
    },
  ];

  return (
    <div className="nc-PageHome relative overflow-hidden">
      <Helmet>
        <title>Devi Plastic | Premium Sink Coupling Manufacturer</title>

        {/* <title>Devi Plastic | Premium Sink Couplings</title> */}

        <meta
          name="description"
          content="Devi Plastic is a trusted manufacturer of premium sink couplings in Ahmedabad, Gujarat. Explore heavy, lite, jumbo & royal sink waste couplings for kitchen and bathroom drainage across India."
        />

        <meta
          name="keywords"
          content="
  sink coupling manufacturer,
  sink coupling supplier,
  sink waste coupling manufacturer,
  plastic sink coupling manufacturer,
  heavy sink coupling,
  lite sink coupling,
  jumbo sink coupling,
  royal sink coupling,
  kitchen sink coupling,
  bathroom sink coupling,
  drainage fittings manufacturer,
  plastic plumbing fittings,
  sink coupling manufacturer in India,
  sink coupling manufacturer in Ahmedabad,
  sink coupling manufacturer in Gujarat,
  Devi Plastic
  "
        />

        <link rel="canonical" href="https://www.deviplastic.in/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Devi Plastic | Sink Coupling Manufacturer in India"
        />
        <meta
          property="og:description"
          content="Explore premium heavy, lite, jumbo & royal sink couplings by Devi Plastic – trusted plastic drainage fittings manufacturer from Ahmedabad."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.deviplastic.in/" />
        <meta
          property="og:image"
          content="https://www.deviplastic.in/og-home.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Devi Plastic | Premium Sink Couplings"
        />
        <meta
          name="twitter:description"
          content="High-quality sink couplings & drainage fittings manufacturer from Ahmedabad, Gujarat."
        />

        {/* PRODUCT LIST SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Devi Plastic Sink Couplings",
            itemListElement: dataofProducts.map(
              (product: any, index: number) => ({
                "@type": "Product",
                position: index + 1,
                name: product.name,
                description: product.description,
                category: product.category,
                image: `https://www.deviplastic.in${product.image}`, // ✅ REQUIRED
                url: `https://www.deviplastic.in${product.link}`,
                brand: {
                  "@type": "Brand",
                  name: "Devi Plastic",
                },
                offers: {
                  "@type": "Offer",
                  priceCurrency: "INR",
                  price: product.price,
                  availability: "https://schema.org/InStock",
                  url: `https://www.deviplastic.in${product.link}`,
                },
              })
            ),
          })}
        </script>
      </Helmet>

      {/* SECTION HERO */}

      <SectionHero2 />
      {/* <AnimatedSilder /> */}
      <div className="mt-5 lg:mt-32">
        <SectionOurIntroduction />
      </div>
      <div className="mt-5 lg:mt-32">
        <SectionOurExperience />
      </div>

      {/* <div className="mt-24 lg:mt-10 h-full">
        <HeroParallax products={Products} />
      </div> */}

      {/* <div className="mt-24 lg:mt-32">
        <DiscoverMoreSlider />
      </div> */}

      <div className="container relative space-y-24 my-5 lg:space-y-32 lg:my-32">
        {/* <h2 className="text-2xl font-semibold">Featured Sink Couplings</h2> */}
        {/* SECTION */}
        <FadeInUpOnScroll defaultClassName="animated" className="fadeInUp">
          <SectionSliderProductCard
            data={[
              dataofProducts[0],
              dataofProducts[1],
              dataofProducts[2],
              dataofProducts[3],

              dataofProducts[0],
              dataofProducts[1],
              dataofProducts[2],
              dataofProducts[3],
            ]}
          />
        </FadeInUpOnScroll>
      </div>
      <div className="container mt-12 lg:mt-16">
        <SectionSeo />
      </div>
    </div>
  );
}

export default PageHome;
